function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './intro.component.scss';
import template from './intro.html';
import { getCurrentDay } from "redesign/shared/helpers/date-time";

export var IntroComponent = {
  template: template,
  styles: styles,
  bindings: {
    onPausePlan: '&',
    showIntro: '=' },

  controller: /*#__PURE__*/function () {IntroComponentController.$inject = ["$timeout", "$filter", "$http", "$q", "$rootScope", "UserService", "MiscModel", "CheckinModel", "gplansConf", "MealPlanService", "Intercom"];
    function IntroComponentController($timeout, $filter, $http, $q, $rootScope, UserService, MiscModel, CheckinModel, gplansConf, MealPlanService, Intercom) {
      "ngInject";_classCallCheck(this, IntroComponentController);
      console.log(this);
      this.currentSlide = 0;
      this.$timeout = $timeout;
      this.$filter = $filter;
      this.$http = $http;
      this.$q = $q;
      this.$rootScope = $rootScope;
      this.yesterday = function (d) {return new Date(d.setDate(d.getDate() - 1));}(new Date()).toString();
      this.UserService = UserService;
      this.MiscModel = MiscModel;
      this.CheckinModel = CheckinModel;
      this.gplansConf = gplansConf;
      this.MealPlanService = MealPlanService;
      this.Intercom = Intercom;
      this.restriction = this.UserService.data.restriction;
      this.startDate = this.getTodayInFormat();
      this.fitpicLoading = false;
      this.screens = [
      {
        id: 1,
        type: 'start',
        title: 'Welcome to G-Plans!',
        subtitle: 'Lets go over a few things before we begin!',
        textBtn: 'Cool, Let’s Begin!',
        image: 'intro-screen-1' },

      {
        id: 2,
        type: 'go',
        title: 'to your body!',
        titleY: 'Custom ',
        subtitle: 'All your meals, portion sizes macros, recipes are 100% custom to your body!',
        textBtn: 'Got It',
        image: 'intro-screen-2' },

      {
        id: 3,
        type: 'go',
        title: 'New Meal Plan, ',
        titleY: 'Weekly',
        subtitle: 'Your body changes, and your meal plan will too!  Every 7 days we will update you plan!',
        textBtn: 'Got It',
        image: 'intro-screen-3' },

      {
        id: 4,
        type: 'go',
        title: 'Your Plan',
        titleY: 'Trust ',
        subtitle: 'Changing the way you eat is hard, but it’s important to trust your plan, portion sizes and all!',
        textBtn: 'Got It',
        image: 'intro-screen-4' },

      {
        id: 5,
        type: 'go',
        title: 'Not Perfection',
        titleY: 'Progress ',
        subtitle: 'Falling off plan is normal, but it’s important to keep trying.  You will get there!',
        textBtn: 'Got It',
        image: 'intro-screen-5' },

      {
        id: 6,
        type: 'go',
        title: 'Check-in Day',
        subtitle: 'Once a week you will Check-in by answering a few questions, to track your progress.',
        textBtn: 'Got It',
        image: 'intro-screen-6' },

      {
        id: 7,
        type: 'picker',
        title: 'When do you want to start?',
        subtitle: 'If you need a few days to ease into your program, you can pick your start day here.',
        textBtn: 'Done' },

      {
        id: 8,
        type: 'fitpic',
        title: 'Let’s Take a FitPic to track Progress!' },

      {
        id: 9,
        type: 'gears',
        title: 'Let’s Customize your Foods',
        subtitle: 'G-Plans will automatically create the perfect portions based on your food preferences',
        textBtn: 'Pick My Foods',
        image: 'intro-screen-9' },

      {
        id: 101,
        type: 'fav',
        title: 'What are your favorite',
        titleY: '',
        smalltitle: 'You can always swap out items later, this will be to just get started. ',
        textBtn: 'Next',
        image: 'intro-screen-10' },

      {
        id: 102,
        type: 'fav',
        title: 'What are your favorite',
        titleY: 'veggies',
        smalltitle: 'You can always swap out items later, this will be to just get started. ',
        textBtn: 'Next',
        image: 'intro-screen-102' },

      {
        id: 103,
        type: 'fav',
        title: 'What are your favorite',
        titleY: 'snacks',
        smalltitle: 'You can always swap out items later, this will be to just get started. ',
        textBtn: 'Next',
        image: 'intro-screen-103' },

      {
        id: 11,
        type: 'calc',
        title: 'Calculating Your Upcoming Week',
        smalltitle: 'One Moment Please…',
        image: 'intro-screen-11' },

      {
        id: 12,
        type: 'finish',
        title: 'Complete! You are all set',
        smalltitle: 'Your plan is updated and ready to go!',
        image: 'intro-screen-logo',
        textBtn: 'See My Plan' },

      {
        id: 13,
        type: 'destroy' }];



      this.veggies = [
      { name: 'Everything' },
      { category: "dr. goglia's superfoods", name: 'Superfoods (broccoli, kale, ect.)' },
      { category: 'leafy greens', name: 'Leafy greens' },
      { category: 'root vegetables', name: 'Roots veggies' },
      { category: 'squash', name: 'Squashes' }];


      this.snacks = [
      { name: 'Everything' },
      { category: 'berries', name: 'Berries' },
      { category: 'apples, bananas, etc.', name: 'Apples and bananas (etc)' },
      { category: 'citrus', name: 'Citrus (Oranges, Grapefruit, ect.)' },
      { category: 'melons', name: 'Melons (Watermelon, Cantaloupe, ect.)' }];


      var diets = {
        default: [
        { name: 'Everything' },
        { category: 'red meat', name: 'Red meat (Steak, Ground Beef, ect.)' },
        { category: 'poultry', name: 'Poultry (Chicken, Turkey, ect)' },
        { category: 'seafood', name: 'Seafood (all fish)' },
        { category: 'vegetarian', name: 'Tofu/Vegetarian' },
        { category: 'shellfish', name: 'Shellfish  (shrimp, Mussels, ect.)' }],

        vegetarian: [
        { name: 'Everything' },
        { category: 'eggs', name: 'Eggs' },
        { id: 955, name: 'Tofu' },
        { id: 820, name: 'Lentils' },
        { id: 959, name: 'Tempeh' },
        { id: 733, name: 'Beans' },
        { id: 812, name: 'Quinoa' }],

        vegan: [
        { name: 'Everything' },
        { id: 955, name: 'Tofu' },
        { id: 820, name: 'Lentils' },
        { id: 959, name: 'Tempeh' },
        { id: 733, name: 'Beans' },
        { id: 812, name: 'Quinoa' }],

        pescetarian: [
        { name: 'Everything' },
        { id: 905, name: 'Salmon' },
        { id: 920, name: 'White Fish' },
        { id: 910, name: 'Shrimp' },
        { category: 'eggs', name: 'Eggs' },
        { id: 908, name: 'Sea Bass' },
        { id: 955, name: 'Tofu' }] };



      this.actualDiet = this.restriction === 'Vegetarian' ?
      diets.vegetarian :
      this.restriction === 'Vegan' ?
      diets.vegan :
      this.restriction === 'Pescetarian' ?
      diets.pescetarian :
      diets.default;

      this.titleProteins = this.restriction === 'Vegetarian' ?
      'vegetarian proteins' :
      this.restriction === 'Vegan' ?
      'vegan proteins' :
      this.restriction === 'Pescetarian' ?
      'pescetarian proteins' :
      'proteins';

      this.calculating = [
      'Calculating Plan',
      'Updating Macronutrients',
      'Perfect Portions',
      'Recalculating Recipes',
      'Finishing Touches'];

    }_createClass(IntroComponentController, [{ key: "$onInit", value: function $onInit()

      {
        angular.element('body').css({ 'overflow': 'hidden' });
        this.Intercom.afterIntercomMessengerBooted(function (el) {
          el.style.visibility = 'hidden';
          el.style.opacity = 0;
          //el.style.display = 'none';
          //el.style.zIndex = -1;
          //el.style.position = 'absolute';
        });
        //this.startDate = this.$filter('date')(new Date(), 'yyyy-MM-dd');
      } }, { key: "$onDestroy", value: function $onDestroy()

      {
        angular.element('body').css({ 'overflow': '' });
        this.Intercom.afterIntercomMessengerBooted(function (el) {
          el.style.visibility = 'visible';
          el.style.opacity = 1;
          //el.style.display = 'block';
          //el.style.zIndex = 'auto';
          //el.style.position = 'static';
        });
      } }, { key: "onSlideChanged", value: function onSlideChanged(

      index) {var _this = this;
        this.currentSlide = index;
        if (this.screens[index].type === 'calc') {
          angular.element('.intro-component__calculate_item').addClass('is-animate');
          this.$timeout(function () {
            _this.currentSlide = _this.currentSlide + 1;
          }, 6800);
        }

        angular.element('.swiper-container').scrollTop(0);
      } }, { key: "slideNext", value: function slideNext()

      {var _this2 = this;
        this.currentSlide = this.currentSlide + 1;
        if (this.screens[this.currentSlide].type === 'fitpic') {
          this.checkNewDate();
        } else
        if (this.screens[this.currentSlide].type === 'calc') {
          this.saveFavoriteFood();
        } else
        if (this.screens[this.currentSlide].type === 'destroy') {
          var starterGuideSeen = new this.MiscModel({
            value: '1',
            key: 'starterGuideSeen' });

          starterGuideSeen.$save().then(function () {
            _this2.$q.resolve().
            then(function () {return _this2.$q(function (rs, rj) {return _this2.$timeout(rs, 1800);});}).
            then(function () {return _this2.showIntro = false;}).
            then(function () {return _this2.$q(function (rs, rj) {return _this2.$timeout(rs, 100);});}).
            then(function () {return _this2.$rootScope.$broadcast('onIntroDestroy');});
          });
        }
      } }, { key: "getTodayInFormat", value: function getTodayInFormat()

      {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
      } }, { key: "checkNewDate", value: function checkNewDate()

      {var _this3 = this;
        var today_in_string = this.getTodayInFormat();
        if (this.startDate != today_in_string) {
          if (this.UserService.data.last_checkin.day != 1) {
            var checkin = new this.CheckinModel(_objectSpread({},
            this.UserService.data.last_checkin));

            if (!checkin.waist) {
              delete checkin.waist;
            }
            if (!checkin.hips) {
              delete checkin.hips;
            }
            delete checkin.created_at;
            delete checkin.id;
            checkin.$save().
            then(function (res) {
              console.warn('checkin ok', res);
            }).
            catch(function (err) {
              console.warn('checkin error', err);
            });
          }
          var checkinDay = getCurrentDay(this.UserService.data.last_checkin.created_at);

          var mealPlanPaused = new this.MiscModel({
            id: 'mealPlanPaused',
            value: checkinDay,
            key: 'mealPlanPaused' });

          mealPlanPaused.$save().then(
          function (res) {
            _this3.pauseSuccessFn(res);
          },
          function (err) {
            delete mealPlanPaused.id;
            mealPlanPaused.$save().then(function (res) {
              _this3.pauseSuccessFn(res);
            });
          });
        }
      } }, { key: "pauseSuccessFn", value: function pauseSuccessFn(

      res) {
        var mealPlanPaused = parseInt(res.value) > 0;
        var mealPlanStartDate = new this.MiscModel({
          id: 'mealPlanStartDate',
          value: this.startDate,
          key: 'mealPlanStartDate' });

        mealPlanStartDate.$save().then(
        function (res) {
        },
        function (err) {
          delete mealPlanStartDate.id;
          mealPlanStartDate.$save();
        });
        this.onPausePlan({ data: { mealPlanPaused: mealPlanPaused, mealPlanStartDate: mealPlanStartDate.value } });
      } }, { key: "fileNameChanged", value: function fileNameChanged(

      $event) {
        this.fileName = $event.target.files[0].name;
        this.image = $event.target.files[0];
        this.showSaveButton = true;
      } }, { key: "saveImage", value: function saveImage()

      {var _this4 = this;
        var fd = new FormData();
        fd.append('image', this.image);
        fd.append('checkin', this.UserService.data.last_checkin.id);
        this.fitpicLoading = true;
        this.$http.post(this.gplansConf.API_URL + '/api/v1/checkin-images/', fd, {
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined } }).

        then(function (res) {
          _this4.image = null;
          _this4.fileName = null;
          _this4.showSaveButton = false;
          _this4.fitpicLoading = false;
          _this4.slideNext();
        }, function (err) {
          console.log('checkin image fail ' + err.data);
        });
      } }, { key: "selectAll", value: function selectAll(

      event, data) {
        var parent = $(event.currentTarget).parent();
        var all = parent.find('.fav-food-checkbox-all').prop('checked');
        if (all) {
          parent.find('.fav-food-checkbox').prop('checked', true);
          for (var i = 0; i < data.length; i++) {
            var item = data[i];
            item.checked = true;
          }
        } else
        {
          parent.find('.fav-food-checkbox').prop('checked', false);
          for (var _i = 0; _i < data.length; _i++) {
            var _item = data[_i];
            _item.checked = false;
          }
        }
      } }, { key: "selectOnce", value: function selectOnce(

      event) {
        var parent = $(event.currentTarget).parent();
        parent.find('.fav-food-checkbox:checked').length === parent.find('.fav-food-checkbox').length ?
        parent.find('.fav-food-checkbox-all').prop('checked', true) :
        parent.find('.fav-food-checkbox-all').prop('checked', false);
      } }, { key: "getFoodsOrSubcategories", value: function getFoodsOrSubcategories(

      data) {
        var subcategories = [];
        var foods = [];
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          if (item.checked) {
            if (item.hasOwnProperty('category')) {
              subcategories.push(item.category);
            } else
            if (item.hasOwnProperty('id')) {
              foods.push(item.id);
            }
          }
        }
        return { subcategories: subcategories, foods: foods };
      } }, { key: "saveFavoriteFood", value: function saveFavoriteFood()

      {var _this5 = this;
        var subcategories = [];
        var foods = [];
        var fromFunction;
        var datas = [this.actualDiet, this.veggies, this.snacks];
        for (var i = 0; i < datas.length; i++) {
          var data = datas[i];
          fromFunction = this.getFoodsOrSubcategories(data);
          subcategories = subcategories.concat(fromFunction.subcategories);
          foods = foods.concat(fromFunction.foods);
        }
        this.$http.post(this.gplansConf.API_URL + '/api/v1/pick-favorite-food/', {
          'subcategories': subcategories,
          'foods': foods }).
        then(
        function (res) {
          _this5.MealPlanService.fetch();
        });

      } }]);return IntroComponentController;}() };



if (module.hot) module.hot.accept('./intro.component.scss');